<template>
  <div class="email-unverified-page">
    <img class="layout__q-logo" src="/images/logo-small.svg" />

    <div class="email-unverified-page__wrapper">
      <!--  Content-->
      <div class="email-unverified-page__wrapper__content">
        <!-- Logo -->
        <div class="email-unverified-page__wrapper__content__logo">
          <img
            class="email-unverified-page__wrapper__logo__img"
            :src="`/images/logo.svg`"
            alt="OWQLO"
          />
        </div>

        <!-- Picture -->
        <div class="email-unverified-page__wrapper__content__picture">
          <!-- Img -->
          <img
            class="email-unverified-page__wrapper__content__picture__img"
            :src="`/images/email-verification.png`"
            alt="OWQLO"
          />
        </div>

        <!-- Title -->
        <h3 class="email-unverified-page__wrapper__content__title"
            style="font-weight: normal; text-align: center"
        >
          <app-i18n :args="[namePropert]" code="auth.emailUnverified.welcome"></app-i18n>
        </h3>

        <!-- Description -->
        <h3
          class="email-unverified-page__wrapper__content__description"
          style="font-weight: normal; text-align: center"
        >
          <app-i18n :args="[email]" code="auth.emailUnverified.message"></app-i18n>
        </h3>

        <!-- Submit -->
        <el-button
          class="email-unverified-page__wrapper__content__submit"
          :loading="loading"
          @click.prevent="doSubmit"
          type="primary"
        >
          <app-i18n code="auth.emailUnverified.submit"></app-i18n>
        </el-button>

        <!-- Sign out -->
        <div class="email-unverified-page__wrapper__content__signout">
          <el-button @click="doSignout({navigateOnSubmit: true})" type="text">
            <app-i18n code="auth.signout"></app-i18n>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { UserModel } from '@modules/auth/user-model';

export default {
  name: 'app-email-unverified-page',

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      loading: 'auth/loadingEmailConfirmation',
      email: 'auth/currentUserEmail',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({ dateFormat, timeFormat }).fields();
    },

    rules() {
      const { fields } = this;
      return {
         email: fields.email.forFormRules(),
      };
    },

    namePropert() {
      return 'OWQLO';
    },

    originUrl() {
      return window.location.href
    }
  },

  methods: {
    ...mapActions({
      doSendEmailConfirmation:
        'auth/doSendEmailConfirmation',
      doSignout: 'auth/doSignout',
    }),

    async doSubmit($event) {
      if ($event) $event.preventDefault()

      await this.doSendEmailConfirmation({ originUrl: this.originUrl });
    },
  },
};
</script>


<style lang="scss" scoped>
.email-unverified-page .layout__q-logo {
  width: 800px;
}

.email-unverified-page .email-unverified-page__wrapper {
  @include auth-mixin;

  background-color: white;
  position: absolute;
  width: 754px;
  height: 810px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  padding: 4em 3em 3em 3em;

  &__content {
    font-weight: normal;
    color: #333333;

    display: grid;
    align-content: center;
    grid-template-rows: 185px 183px 80px auto 70px 70px;
    grid-template-columns: 80px auto 80px;
    grid-template-areas:
      '. logo .'
      '. picture .'
      '. title .'
      '. description .'
      '. submit .'
      '. signout .';
    grid-gap: 5px;

    &__logo {
      grid-area: logo;
      text-align: left;
      
      @include mobile {
       text-align: center;
       align-self: center;
      }
    }
    &__picture {
      grid-area: picture;

      &__img {
        width: 219px;
        height: 183px;
      }
    }
    &__title {
      grid-area: title;
      font-size: 30px;
    }
    &__description {
      grid-area: description;
      font-size: 18px;
    }
    &__submit {
      min-width: 300px;
      grid-area: submit;
      align-self: center;
      justify-self: center;
      
      @include small-mobile {
        font-size: 12px;
      }
    }
    &__signout {
      grid-area: signout;
    }

    @include mobile { 
      grid-template-columns: auto auto auto;
       background-color: white;
    }
  }

  @include small-mobile {
    width: 100vw;
    height: 100vh;
    display: grid;
    padding: 0 0 0 0;
    background-color: white;
  }

  @include mobile {
    width: 100vw;
    height: 100vh;
    display: grid;
    padding: 0 0 0 0;
    background-color: white;
  }
}
</style>
